import React from 'react'
import { Box } from '@chatterbug/aaron'

const VerticalDivider = () => {
  // width={1} becomes fat for some reason
  return <Box width="1px" height={56} as="hr" border="none" bg="gray88"></Box>
}

export default VerticalDivider
